<template>
  <main class="main">
    <div class="group group--narrow support support--start">
      <form class="form form--inline" @submit.prevent="submitForm">
        <div class="form-wrap">
          <transition-group name="intake">
            <div class="" v-for="(option, key) in options" :key="`field-${key}`">
              <label class="form-label">
                <span class="form-label__label">{{ option.text }}</span>
                <div class="form-wrap">
                  <select
                    :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                    class="form-select"
                    v-model="option_id[key]"
                    @change="handleSelect(option, $event, key)"
                  >
                    <option
                      disabled
                      :value="null"
                      selected
                    />
                    <option
                      v-for="(first, key) in getOptions[key]"
                      :key="key"
                      :value="first.text"
                    >{{ first.text }}</option>
                  </select>
                  <span class="form-arrow" />
                </div>
              </label>
            </div>
          </transition-group>
        </div>

        <transition name="button">
          <module-button button="primary" v-if="showButton || options.length > 3">Continue</module-button>
        </transition>
      </form>

      <img class="support__image" :src="image" alt="">
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { HTTP } from 'api/http';

import people from 'images/intake/people.png';

const images = {
  people,
};

const stored = ['Who', 'Location', 'Complaint', 'SecondaryComplaint'];

// Export
export default {
  name: 'view-support',

  // Components
  components: {},

  data() {
    return {
      image: images.people,
      form: {},
      options: [],
      output: [],
      option_id: [],
      showButton: false,
      questionsCount: stored.length,
      getOptions: [],
      startAnswer: {},
    };
  },

  computed: {
    ...mapGetters('questions', ['startingQuestion', 'questions']),
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('app', ['org']),

    view() {
      return this.getFormView('intake');
    },
  },

  methods: {
    ...mapActions('questions', [
      'requestQuestions',
      'requestStartingQuestion',
      'requestSingleQuestion',
    ]),

    ...mapActions('answers', [
      'requestAnswer',
      'requestAddAnswer',
      'requestUpdateAnswer',
      'checkIntakeStatus',
    ]),

    submitForm() {
      this.$router.push('/help-myself');
    },

    handleSelect(option, e, key) {
      // Build the response
      const buildQ = {
        question: option.id,
        text: option.text,
        choices: option.choices,
        answer: e.target.value,
        nested_question: option.nested_question,
      };

      this.options.forEach((item, index) => {
        if (item.id === buildQ.question) {
          localStorage.setItem(`answer${stored[index]}`, buildQ.answer);
        }

        if (key === index) {
          if (localStorage.getItem(`object${stored[index]}`)) {
            const getItem = JSON.parse(
              localStorage.getItem(`object${stored[index]}`)
            );
            getItem.answer = buildQ.answer;
            localStorage.setItem(
              `object${stored[index]}`,
              JSON.stringify(getItem)
            );
          } else {
            localStorage.setItem(
              `object${stored[index]}`,
              JSON.stringify(buildQ)
            );
          }

          if (item.nested_question) {
            this.requestSingleQuestion(item.nested_question)
              .then(res => {
                const obj = {
                  ...res.data,
                  answer:
                    localStorage.getItem(`answer${stored[index + 1]}`) || null,
                };
                localStorage.setItem(
                  `object${stored[index + 1]}`,
                  JSON.stringify(obj)
                );
              })
              .catch(err => err);
          }
        }
      });

      this.output.push(buildQ);

      const answer = buildQ.answer;

      if (answer === 'A Co-Worker') {
        this.$router.push({ name: 'others-help', params: { id: 'co-worker' } });
        delete HTTP.defaults.headers.common.Authorization;
      }

      if (answer === 'A Dependent' || answer === 'My Partner') {
        this.$router.push({ name: 'help-someone' });
        delete HTTP.defaults.headers.common.Authorization;
      }

      if (option.nested_question) {
        this.requestSingleQuestion(option.nested_question)
          .then(res => {
            const optionLength = this.options.length;
            const idLength = this.option_id.length;

            if (
              optionLength === idLength &&
              optionLength !== this.questionsCount
            ) {
              this.options.push(res.data);
              this.getOptions.push(res.data.choices);
            }

            if (!res.data.nested_question) {
              this.showButton = true;
            }
          })
          .catch();
      }

      if (option.is_start && this.options.length > 0) {
        this.requestAnswer(this.output)
          .then(res => {
            this.startAnswer = res.data;
          })
          .catch(err => err);
      } else {

        if (this.startAnswer.answer_token && !localStorage.getItem('answer_token')) {
          HTTP.defaults.headers.common.Authorization = `Token ${this.startAnswer.answer_token}`;
        } else {
          HTTP.defaults.headers.common.Authorization = `Token ${localStorage.getItem(
            'answer_token'
          )}`;
        }

        this.requestAddAnswer({
          id: this.startAnswer.id
            ? this.startAnswer.id
            : localStorage.getItem('singleAnswer'),
          model: buildQ,
          output: this.output,
        })
          .then(() => {
            delete HTTP.defaults.headers.common.Authorization;
          })
          .catch(() => {
            delete HTTP.defaults.headers.common.Authorization;
          });
      }
    },
  },

  created() {
    if ( this.isAuthenticated ) {
      this.$router.push({ name: 'home' });

      return;
    }

    // First question requesr and
    delete HTTP.defaults.headers.common.Authorization;

    this.checkIntakeStatus();

    if (localStorage.getItem('objectWho')) {
      stored.forEach(item => {
        const getItem = JSON.parse(localStorage.getItem(`object${item}`));
        if (getItem) {
          this.options.push(getItem);
          this.getOptions.push(getItem.choices);
          this.option_id.push(getItem.answer);
        }
      });
    } else {
      this.requestStartingQuestion().then(res => {
        this.options.push(res.data);
        this.getOptions = [res.data.choices];
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// Support.vue?3185f642